import innerbannerCommon from "../../common/images/img/inner-banner.jpg";
const hostname = window.location.hostname.replace(/^www\./, '');
const configData = {
    localhost : {
         appName:"barbqtonight",
        uniqueID:"0ade79ef-6932-47ee-803f-0af129273eff",
        mainUrl:"https://bbqtonight.goepicware.com/",
        CountryName:"Singapore",
        folderName:"barbqtonight",
        companyName:"Bar.B.Q Tonight Restaurant",
        currency:"$",
        themeClass:"orange-theme",
        mainPage:'home',
        menuNavType:'top',
        menuPage:'products',
        termsEmail:'info@barbqtonight.com.sg',
        termsEmailLink:'/',
        innerbannerPath:'Yes'
    },
    '192.168.0.92' : {
        appName:"sushitei",
        uniqueID:"eff79827-0453-4121-9ec9-541eb2ca6d7e",
        mainUrl:"http://localhost:3000/",
        CountryName:"Singapore",
        folderName:"sushitei",
        companyName:"Sushi Tei",
        currency:"$",
        themeClass:"green-theme",
        mainPage:'product',
        menuNavType:'left',
        menuPage:'menu',
        termsEmail:'dpo@sushitei.com',
        termsEmailLink:'https://sushitei.com/privacy-policy/'
    },
    'sushitei.goepicware.com' : {
        appName:"sushitei",
        uniqueID:"eff79827-0453-4121-9ec9-541eb2ca6d7e",
        mainUrl:"https://sushitei.goepicware.com/",
        CountryName:"Singapore",
        folderName:"sushitei",
        companyName:"Sushi Tei",
        currency:"$",
        themeClass:"green-theme",
        mainPage:'product',
        menuNavType:'left',
        menuPage:'products',
        termsEmail:'dpo@sushitei.com',
        termsEmailLink:'https://sushitei.com/privacy-policy/'
    },   
    'ecomfront.goepicware.com' : {
        appName:"chirashizushishou",
        uniqueID:"b079b91f-f9c4-42ad-b334-faf50132a1b9",
        mainUrl:"https://ecomfront.goepicware.com/",
        CountryName:"Singapore",
        folderName:"chirashizushishou",
        companyName:"Chirashizushishou",
        currency:"$",
        themeClass:"orange-theme",
        mainPage:'home',
        menuNavType:'top',
        menuPage:'products',
        termsEmail:'dpo@chirashizushishou.com',
        termsEmailLink:'/'
    },
    'ajmirbriyani.goepicware.com' : {
        appName:"ajmirbriyani",
        uniqueID:"61da597f-f4b8-4a68-a680-d548b1bd53c6",
        mainUrl:"https://ajmirbriyani.goepicware.com/",
        CountryName:"Singapore",
        folderName:"ajmirbriyani",
        companyName:"Ajmir Briyani",
        currency:"$",
        themeClass:"orange-theme",
        mainPage:'home',
        menuNavType:'top',
        menuPage:'menu',
        termsEmail:'enquiry@ajmirbriyani.com',
        termsEmailLink:'/'
    },
    "ajmirbriyani.com" : {
        appName:"ajmirbriyani",
        uniqueID:"61da597f-f4b8-4a68-a680-d548b1bd53c6",
        mainUrl:"https://www.ajmirbriyani.com/",
        CountryName:"Singapore",
        folderName:"ajmirbriyani",
        companyName:"Ajmir Briyani",
        currency:"$",
        themeClass:"orange-theme",
        mainPage:'home',
        menuNavType:'top',
        menuPage:'menu',
        termsEmail:'enquiry@ajmirbriyani.com',
        termsEmailLink:'/'
    },   
    "bbqtonight.goepicware.com" : {
        appName:"barbqtonight",
        uniqueID:"0ade79ef-6932-47ee-803f-0af129273eff",
        mainUrl:"https://bbqtonight.goepicware.com/",
        CountryName:"Singapore",
        folderName:"barbqtonight",
        companyName:"Bar.B.Q Tonight Restaurant",
        currency:"$",
        themeClass:"orange-theme",
        mainPage:'home',
        menuNavType:'top',
        menuPage:'products',
        termsEmail:'info@barbqtonight.com.sg',
        termsEmailLink:'/',
        innerbannerPath:'Yes'
    },
    "order.bbqtonight.com.sg" : {
        appName:"barbqtonight",
        uniqueID:"0ade79ef-6932-47ee-803f-0af129273eff",
        mainUrl:"https://order.bbqtonight.com.sg/",
        CountryName:"Singapore",
        folderName:"barbqtonight",
        companyName:"Bar.B.Q Tonight Restaurant",
        currency:"$",
        themeClass:"orange-theme",
        mainPage:'home',
        menuNavType:'top',
        menuPage:'products',
        termsEmail:'info@barbqtonight.com.sg',
        termsEmailLink:'/',
        innerbannerPath:'Yes'
    },
    "tigafolks.goepicware.com" : {
        appName:"tigafolks",
        uniqueID:"1f01fcd2-d342-4cb6-b08b-d417ab72473a",
        mainUrl:"https://tigafolks.goepicware.com/",
        CountryName:"Singapore",
        folderName:"tigafolks",
        companyName:"Tigafolks & Co.",
        currency:"$",
        themeClass:"orange-theme",
        mainPage:'home',
        menuNavType:'top',
        menuPage:'products',
        termsEmail:'info@tigafolks.co',
        termsEmailLink:'/'
    },
    "almahboob.goepicware.com" : {
        appName:"almahboobrojak",
        uniqueID:"72e1006a-beaa-485e-be6c-c6acb313ea08",
        mainUrl:"https://almahboob.goepicware.com/",
        CountryName:"Singapore",
        folderName:"almahboobrojak",
        companyName:"AL Mahboob Rojak Restaurant Pte. Ltd.",
        currency:"$",
        themeClass:"orange-theme",
        mainPage:'home',
        menuNavType:'top',
        menuPage:'products',
        termsEmail:'info@almahboobrojak.com',
        termsEmailLink:'/'
    },
    "machanskitchen.goepicware.com" : {
        appName:"machanskitchen",
        uniqueID:"a6538f71-f415-4d52-89ab-0d2434088328",
        mainUrl:"https://machanskitchen.goepicware.com/",
        CountryName:"Singapore",
        folderName:"machanskitchen",
        companyName:"Machan's Kitchen",
        currency:"$",
        themeClass:"orange-theme",
        mainPage:'home',
        menuNavType:'top',
        menuPage:'products',
        termsEmail:'info@machanskitchen.com',
        termsEmailLink:'/'
    },
    "srisunexpress.goepicware.com" : {
        appName:"srisun",
        uniqueID:"979cc683-3096-4f02-9556-342a16c0f27d",
        mainUrl:"https://srisunexpress.goepicware.com/",
        CountryName:"Singapore",
        folderName:"srisun",
        companyName:"Srisun Express",
        currency:"$",
        themeClass:"orange-theme",
        mainPage:'home',
        menuNavType:'top',
        menuPage:'products',
        termsEmail:'info@https://srisunexpress.com.sg/',
        termsEmailLink:'/'
    },
}

export const mainAPIURL = 'https://ecomapi.goepicware.com/';
export const apiUrl = 'https://ecomapi.goepicware.com/api/';
export const epciPayAPIURL = 'https://walletapi.epicpay.ai/api/';

/* export const mainAPIURL = 'https://uatecomapi.goepicware.com/'
export const apiUrl = 'https://uatecomapi.goepicware.com/api/';
export const epciPayAPIURL = 'https://uatwalletapi.epicpay.ai/api/' */


/* export const mainAPIURL = 'http://localhost:3006/'
export const apiUrl = 'http://localhost:3006/api/';
export const epciPayAPIURL = 'http://localhost:3005/api/' */

export const deliveryId = "e405c6e5-1526-443d-8809-e149df521133";
export const pickupId = "962ac11f-aaf3-4ba0-8417-b7efb812b939";

export const uniqueID = configData[hostname].uniqueID;
export const appName = configData[hostname]?.appName??'common';

export const mainUrl = configData[hostname].mainUrl;
export const CountryName = configData[hostname].CountryName;
export const productNoImg = configData[hostname].productNoImg;
export const companyName = configData[hostname].companyName;
export const currency = configData[hostname].currency;
export const themeClass = configData[hostname].themeClass;
export const mainPage = configData[hostname].mainPage;
export const menuNavType = configData[hostname].menuNavType;
export const siteLogo = "/img/" + configData[hostname].folderName + "/logo.png";
export const favIcon = "/img/" + configData[hostname].folderName + "/favicon.ico";
export const placeholderImage = "/img/" + configData[hostname].folderName + "/placeholder.jpg";
export const paymentImage = "/img/" + configData[hostname].folderName + "/payment.jpg";

export const innerbannerPath = configData[hostname]?.innerbannerPath ?? 'No';

export const innerbanner = innerbannerPath==="Yes"?"/img/" + configData[hostname].folderName + "/innerbanner.png":innerbannerCommon;
export const termsEmail = configData[hostname].termsEmail;
export const termsEmailLink = configData[hostname].termsEmailLink;

export const menuPage = configData[hostname].menuPage;
